import { IModel, IAttribute } from '../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { WebTableLinkedService } from '../linkedservice/web-table.linkedservice';

import { Dataset } from 'app/model/dataset/dataset';
import { format } from 'app/shared/utils/string.util';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.webTable.datasetType,
    display: [
        format(stringResources.ModelName_DatasetTemplate, stringResources.WebTable_DisplayText),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.WebTable_DisplayText)
    ],
    constraints: {
        linkedService: {
            model: WebTableLinkedService.MODEL // Linked service redefined
        }
    }
})
export class WebTableDataset extends Dataset {
    public static readonly MODEL: IModel;
    public static readonly TABLE_INDEX: IAttribute;
    public static readonly TABLE_PATH: IAttribute;

    @Metamodel.attribute({
        constraint: {
            required: true
        },
        association: 'TABLE_INDEX',
        templatable: true
    })
    public tableIndex?: number;

    @Metamodel.attribute({
        association: 'TABLE_PATH',
        templatable: true
    })
    public tablePath?: string;

    public constructor(name?: string, description?: string) {
        super(name, description);
    }
}
